import { IOption } from 'src/app/components/shared/form/components/form-select/form-select.model';

export const CONSTS = {
  CUSTOMER_SCAN_TYPE_LABEL: $localize`Customer Scan Type`,
  CUSTOMER_VALIDATION_TYPE_LABEL: $localize`Customer Validation Type`,
  CUSTOMER_TYPE_LABEL: $localize`Customer Type`,
  FORCE_AGENT_SCAN: $localize`Force Agent Scan`,
  SCAN_TYPE_HELPER_TEXT: $localize`Applicable to customer with no GLE validation`,
  VALIDATION_TYPE_HELPER_TEXT: $localize`Enabled customer GLE validation`,
  SITE_TYPE_PLACEHOLDER: $localize`Enter type`,
  SITE_TYPE: $localize`Site Type`,
  DATA_RETENTION: $localize`Data Retention Days `,
  SMART_OPS_THRESHOLD: $localize`Smart Data Threshold (sec) `,
  WEEKEND_OPS_THRESHOLD: $localize`Weekend Threshold (sec) `,
  RETENTION_PLACEHOLDER: $localize`Enter Data Retention Days`,
};

export const CUSTOMER_SCAN_TYPE_OPTIONS: IOption[] = [
  {
    label: $localize`Drop Shipper - 06`,
    value: '06',
  },
  {
    label: $localize`Direct Shipper - 12`,
    value: '12',
  },
];

export const CUSTOMER_VALIDATION_TYPE_OPTIONS: IOption[] = [
  {
    label: $localize`No Validation`,
    value: '01',
  },
  {
    label: $localize`Agent Scan`,
    value: '02',
  },
  {
    label: $localize`Reprocess`,
    value: '03',
  },
  {
    label: $localize`Reject`,
    value: '04',
  },
];

export const CUSTOMER_TYPE_OPTIONS: IOption[] = [
  {
    label: ' ',
    value: 0,
  },
  {
    label: $localize`UPS Brown`,
    value: 1,
  },
  {
    label: $localize`Customer Site`,
    value: 2,
  },
  {
    label: $localize`OSP`,
    value: 3,
  },
  {
    label: $localize`Customer without Sort Assist`,
    value: 4,
  },
];
